jQuery(document).ready(function($) {
	
	// Build social sharing div & buttons
	var obj = $('.social-sharing');
	
	$.each(obj, function(idx, val) {
		
		// Loader
		var loader = '<div class="share-loader"><i class="fa fa-spinner fa-spin fa-3x" aria-hidden="true"></i><span class="sr-only">Loading</span></div>';
		
		// Get the list of enabled networks and build out button structure
		var data_networks = $(this).attr('data-networks');
		var enabled_networks = data_networks.split(',');
		
		var networks_arr = [];
		for (i=0; i < enabled_networks.length; i++) {
			
			var network_name;
			var network_icon;
			
			if (enabled_networks[i] == 'facebook') {
				network_name = 'Share this page on Facebook';
				network_icon = 'fa fa-facebook';
			} else if (enabled_networks[i] == 'twitter') {
				network_name = 'Share this page on X (formerly Twitter)';
				network_icon = 'fa fa-twitter-x-patch';
			} else if (enabled_networks[i] == 'linkedin') {
				network_name = 'Share this page on LinkedIn';
				network_icon = 'fa fa-linkedin';	
			} else if (enabled_networks[i] == 'pinterest') {
				network_name = 'Share this page on Pinterest';	
				network_icon = 'fa fa-pinterest';
			} else if (enabled_networks[i] == 'google') {
				network_name = 'Share this page on Google Plus';
				network_icon = 'fa fa-google';	
			} else if (enabled_networks[i] == 'envelope') {
				network_name = 'Email this page to a friend';
				network_icon = 'fa fa-envelope';	
			} else {
				network_name = 'Share this page'; // fallback
				network_icon = 'fa fa-share';
			}
			
			networks_arr.push('<button type="button" class="share ' + enabled_networks[i] + '"><span class="sr-only">' + network_name + '</span><i class="' + network_icon + '" aria-hidden="true"></i></button>');
		}
		
		var networks_html = networks_arr.join();
		networks_html = '<div class="share-wrap">' + networks_html + '</div>';
		networks_html = networks_html.replace(/,/g, '');
		
		// Default HTML
		var share_html = networks_html + loader;
		
		$(this).html(share_html);
		
	});
	
	
	// Share button has been clicked, get network and process share logic
	$(document).on('click', '.social-sharing .share', function() {
		
		var class_list = $(this).attr('class').split(/\s+/);
		var network = class_list[1];
		
		var id = $(this).parent().parent().attr('id');

		elon_share_generic(id, network);
		
	});
	
	// Process Facebook share
	function elon_share_facebook(id) {
		
		$('#' + id + ' .share-wrap').hide();
		$('#' + id + ' .share-loader').show();
		
		var image = $('meta[property="og:image"]').attr('content');
		var title = $('meta[property="og:title"]').attr('content');
		var description = $('meta[property="og:description"]').attr('content');
		var url = $('meta[property="og:url"]').attr('content');
		
		FB.ui({
		  method: 'share',
		  mobile_iframe: true,
		  href: 'https://developers.facebook.com/docs/',
		}, function(response){});
		
		$('#' + id + ' .share-loader').hide();
		$('#' + id + ' .share-wrap').show();
		
	}
	
	// Process generic share
	function elon_share_generic(id, network) {
		
		$('#' + id + ' .share-wrap').hide();
		$('#' + id + ' .share-loader').show();
		
		var share_url = $('meta[property="og:url"]').attr('content');
		var data = elon_share_data(network, share_url);
		
		window.open(data[0], data[1], data[2]);
		
		/*
		console.log('network: ' + network);
		console.log('div: ' + id);
		console.log('url: ' + data[0]);
		console.log('target: ' + data[1]);
		console.log('dimensions: ' + data[2]);
		console.log('---');
		*/
		
		$('#' + id + ' .share-loader').hide();
		$('#' + id + ' .share-wrap').show();
		
	}
	
	function elon_share_data(network, share_url) {
		
		var url;
		var target = '_blank';
		var dimensions = 'width=600, height=300';
		var image = $('meta[property="og:image"]').attr('content');
		var title = $('meta[property="og:title"]').attr('content');
		var description = $('meta[property="og:description"]').attr('content');
		
		if (network == 'facebook') {
			
			url = 'https://www.facebook.com/dialog/share?app_id=1398799366859253';
			url = url + '&href=' + encodeURIComponent(share_url);
			url = url + '&redirect_uri=' + encodeURIComponent(share_url);
			//url = url + '&picture=' + encodeURIComponent(image);
			//url = url + '&name=' + encodeURIComponent(title);
			//url = url + '&caption=' + encodeURIComponent(description);
			//url = url + '&description=' + encodeURIComponent(description);
			
			target = 'fbshare';
		
		}
		
		if (network == 'twitter') {
			
			url = 'https://twitter.com/intent/tweet/?url=' + encodeURIComponent(share_url);
			
			var tweet = $('meta[name="elon:share_tweet"]').attr('content');
			if (tweet != undefined) {
				url = url + '&text=' + encodeURIComponent(tweet);
			}
		
		}
		
		if (network == 'linkedin') {
		
			url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(share_url);
			url = url + '&summary=' + encodeURIComponent(description);
			url = url + '&title=' + encodeURIComponent(title);
			url = url + '&source=Elon';
		
		}
		
		if (network == 'google') {
			// RB NOTE (3/5/24): Google Plus is no longer a thing. The only Google "sharing" thing
			// I've found to replace is adding a page to your Google Bookmarks.
			// We should probably phase out the Google option in our sharing functionality.
			// I'm going to remove the Google+ option from the Advanced Element dialog box.
			// But we can keep the javascript and styles for Google for now until we can
			// ensure no one is using this option.
			url = 'https://plus.google.com/share?url=' + encodeURIComponent(share_url);
		
		}
		
		if (network == 'pinterest') {
		
			url = 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(share_url);
			url = url + '&media=' + encodeURIComponent(image);
			url = url + '&description=' + encodeURIComponent(description);
			
			dimensions = '';
		
		}
		
		if (network == 'envelope') {
		
			var subject = $('meta[name="elon:share_email_subject"]').attr('content');
			var bodyContent = $('meta[name="elon:share_email_body"]').attr('content');
			var body = '';
			
			if (bodyContent.trim() !== '') {
				body = bodyContent + '%0A%0A';
			}
			body += encodeURIComponent(share_url);
		
			url = 'mailto:?subject=' + subject + '&body=' + body;
		
			target = '_self';
		
			dimensions = '';
		
		}
		
		var arr = [url, target, dimensions];
		
		return arr;
	}
	
});